<template>
  <div id="app">
    <transition mode="out-in" :name="'fade'">
      <!--
          Passing the the route parameter in Key parameter
          so we have transitions on dynamic components
         -->
      <router-view :key="$route.params.product"></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: "app",
};
</script>



// WEBPACK FOOTER //
// src/App.vue